// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6-rRI","footer":"styles_footer__Tk7or"};